const createPt320InitState = () => ({
  relationList: [],
  categoryList: [],
});

const createPt320ReqModelState = () => ({});

const state = () => ({
  pt320Init: createPt320InitState(),
  pt320ReqModel: createPt320ReqModelState(),
});

const mutations = {
  RESET_PT320_STATE(currentState) {
    currentState.pt320Init = createPt320InitState();
    currentState.pt320ReqModel = createPt320ReqModelState();
  },
  SET_PT320_INIT(currentState, payload = {}) {
    currentState.pt320Init = payload || {};
  },
  MERGE_PT320_INIT(currentState, payload = {}) {
    currentState.pt320Init = Object.assign({}, currentState.pt320Init, payload);
  },
  SET_PT320_REQ_MODEL(currentState, payload = {}) {
    currentState.pt320ReqModel = payload || {};
  },
  MERGE_PT320_REQ_MODEL(currentState, payload = {}) {
    currentState.pt320ReqModel = Object.assign({}, currentState.pt320ReqModel, payload);
  },
};

const getters = {
  pt320Init: currentState => currentState.pt320Init,
  pt320ReqModel: currentState => currentState.pt320ReqModel,
};

export {
  createPt320InitState,
  createPt320ReqModelState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
